<script>
import myMusic from "@/components/contents/parentingAudio/parentingAudio_1.0.vue"; //音频组件
import { fomatterNum, TestUserAgent } from "@/assets/js/common.js"; //工具类
import { audioMixins } from "@/minxs/audio.js";
import audioTimeImg from "@assets/images/icon/audio_time.png";
import audioPlayImg from "@assets/images/icon/audio_play.png";
import API from "@/utils/axiosApi/cageChildApi.js"; //api
export default {
  data() {
    return {
      playId: null, //当前播放id
      audioParams: {}, //当前音频信息
      playIndex: 0, //音频下标
      type: "cagechild", //路由type
      newPageParams: {
        page: 1,
        size: 25,
      }, //分页参数
    };
  },
  components: {
    myMusic,
  },

  props: {
    Index: {
      type: Number,
      default: 0,
    },
    playTime: {
      type: Number,
      default: 0,
    },
    audioList: {
      type: Array,
      default: () => [],
    },
    audioParam: {
      type: Object,
    },
    allNewAudio: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    Index(val) {
      this.playIndex = val;
    },
  },
  mixins: [audioMixins],
  methods: {
    /**
     * @description: 开始播放
     * @param {item}  音频信息
     * @return {index} 下标
     */

    startPlay(item, index) {
      const { isios } = TestUserAgent();
      if (isios) {
        this.$emit("clearTimeWay");
      }
      if (!item.isPlay) {
        item.only = 0 //列表数据
        this.$emit("currentAudioWay", item, index);
      } else {
        this.onLinkTap(item, index);
      }
      this.audioList.forEach((res, i) => {
        if (index == i) {
          res.isPlay = true;
        } else {
          res.isPlay = false;
        }
      });
      this.playIndex = index;
      this.$emit("playSensor", '开始');
    },
  },

  render() {
    return (
      <div>
        <div class="article">
          <div class="article_list">
            {this.audioList.map((res, index) => {
              return (
                <div class="article_box">
                  <div class="audio">
                    <img class="bg_img" v-lazy={res.coverUrl} />
                    <img
                      
                       class={[res.isPlay?'playing':'','play']}
                       onClick={() => this.startPlay(res, index)}
                      src={res.isPlay ? this.playDoctor : this.off}
                    />
                  </div>
                  <div
                    class="article_box_details article_box_border"
                    onClick={() => this.onLinkTap(res, index,'list')}
                  >
                    <div class="title">{res.name}</div>
                    <div class="time">
                      <p>
                        <span>
                          <img src={audioTimeImg} />
                          {res.durationStr || "00:00"}
                        </span>
                        <span>
                          <img src={audioPlayImg} />
                          {fomatterNum(res.watchNum) || 0}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  },
};
</script>
<style lang="less" scoped>
@import "../../../../assets/less/parenAudio.less";
.article .article_list .article_box .article_box_border {
    padding-bottom: 5px;
  border-bottom: solid 1px #F2F2F2;
 
}
</style>
